import { InfoCircle } from "@untitledui/icons";
import { useDisableTwoFactor } from "@/api/security";
import { Button } from "@/components/base/buttons/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { toast } from "@/providers/ToastProvider";
import { PasswordField, usePasswordConfirmation } from "./password-confirmation";

type Props = { open: boolean; onOpenChange: (open: boolean) => void };

const DisableForm = ({ onClose }: { onClose: () => void }) => {
  const disable = useDisableTwoFactor();
  const { form, submit } = usePasswordConfirmation(async (password) => {
    await disable.mutateAsync(password);
    onClose();
    toast("Two-factor authentication disabled", {
      description: "Your account now signs in with a password only.",
      color: "gray",
      icon: InfoCircle,
    });
  });

  return (
    <form className="flex flex-col gap-4" onSubmit={submit} noValidate>
      <DialogTitle className="text-lg leading-7 font-semibold text-gray-900">
        Disable two-factor authentication?
      </DialogTitle>
      <DialogDescription className="text-sm text-gray-600">
        Your account will sign in with a password only, and your backup codes will stop working.
      </DialogDescription>
      <PasswordField control={form.control} label="Confirm your password" />
      <div className="mt-2 flex justify-end gap-3">
        <Button type="button" color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" color="primary-destructive" isLoading={form.formState.isSubmitting}>
          Disable
        </Button>
      </div>
    </form>
  );
};

export const DisableTwoFactorDialog = ({ open, onOpenChange }: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-xl bg-white sm:max-w-[440px]">
      <DisableForm onClose={() => onOpenChange(false)} />
    </DialogContent>
  </Dialog>
);
